import { reactive } from "vue";

export const loaderState = reactive({
  isVisible: false,
});

export const showLoader = () => {
  loaderState.isVisible = true;
};

export const hideLoader = () => {
  loaderState.isVisible = false;
};
